import React from "react";

export const CurrencyContext = React.createContext();

export const currencySymbols = {
    USD: '$',
    EUR: '€',
    RUB: '₽'
};
